import { render, staticRenderFns } from "./ReporteRegistros.vue?vue&type=template&id=c5932778"
import script from "./ReporteRegistros.vue?vue&type=script&lang=js"
export * from "./ReporteRegistros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports